module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/font-control-8eeff617941cc071b98915056d0a7cd4.svg";